export const getTokens = async (CompanyID, ClientID) => {

    try {
        const response = await fetch('https://functionappfordev.azurewebsites.net/api/tokenCrud?method=GET_CHAT_PROFILE', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'X-UserSessionID': localStorage.getItem('UserSessionID') || ''
             },
            // body: JSON.stringify({ CompanyID, ClientID }),
            // credentials: 'include' // Include credentials for CORS
        });

        if (!response.ok) {
            throw new Error('Failed to fetch tokens');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching tokens:', error);
        return [];
    }

  }

  export const sendAnalyticsEvent = async (eventType, metadata = {}) => {

    if (window.location.hostname === 'localhost') {
        console.log(`Analytics event: ${eventType}`, metadata);
        return;
    }

    const sessionId = localStorage.getItem('session_id') || crypto.randomUUID();
    localStorage.setItem('session_id', sessionId);

    try {
        const response = await fetch('https://functionappfordev.azurewebsites.net/api/handleAnalytics', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            // credentials: 'include',
            body: JSON.stringify({
                sessionId,
                eventType,
                metadata,
                timestamp: new Date().toISOString()
            }),
        });

        if (!response.ok) {
            throw new Error('Failed to log analytics event');
        }

        return await response.json();
    } catch (error) {
        console.error('Error sending analytics event:', error);
        return null;
    }
};




export const getClients = async () => {
    try {
      const response = await fetch(
        "https://functionappfordev.azurewebsites.net/api/internalDashHandler"
        , {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "GET_CLIENTS"
        }),
        credentials: "include", // Include credentials (cookies, authorization headers, etc.)
      });
  
      const data = await response.json();
  
      if (response.ok) {
        return data;
      } else {
        throw new Error('Failed to update column');
  
      }
    } catch (error) {
        throw error;  
    }
  };
  






export const getChats = async (clientId) => {
    try {
      const response = await fetch(
        "https://functionappfordev.azurewebsites.net/api/internalDashHandler"
        , {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "GET_CHATS",
          ClientID: clientId
        }),
        credentials: "include", // Include credentials (cookies, authorization headers, etc.)
      });
  
      const data = await response.json();
  
      if (response.ok) {
        return data;
      } else {
        throw new Error('Failed to update column');
  
      }
    } catch (error) {
        throw error;  
    }
  };
  